import React from 'react'
import Snackbar from "./Components/Snackbar";
import Routes from '../src/router/Routes'


export const App = () => {
    return <div className="wrapper">
        <Snackbar/>
        <Routes/>
    </div>
}
export default App
